import { ArrowPathIcon } from '@heroicons/react/24/outline';

import Text from './Text';
import { t } from '../i18n/langue';

/**
 * L'indicateur du geste « glisser pour actualiser ». Dans le FLUX, en tête de liste :
 * sa hauteur suit le doigt et pousse la liste vers le bas, comme une liste native.
 * Décoratif pour les lecteurs d'écran : l'annonce passe par le lien « Actualiser ».
 */
interface IndicateurActualisationProps {
    distance: number;
    pret: boolean;
    enCours: boolean;
}

const HAUTEUR_EN_COURS = 48;

export default function IndicateurActualisation({ distance, pret, enCours }: IndicateurActualisationProps) {
    const hauteur = enCours ? HAUTEUR_EN_COURS : distance;
    if (hauteur <= 0) return null;

    return (
        <div
            aria-hidden="true"
            className="flex items-end justify-center overflow-hidden pb-2"
            // Hauteur dynamique pilotée par le doigt : seule valeur inline, impossible en classe.
            style={{ height: hauteur }}
        >
            <div className="flex items-center gap-2">
                <ArrowPathIcon
                    className={`h-5 w-5 text-main-color transition-transform ${enCours ? 'animate-spin' : ''} ${pret ? 'rotate-180' : ''}`}
                />
                <Text variante="petit" ton="attenue">
                    {enCours
                        ? t('composants.actualisation.enCours')
                        : pret
                          ? t('composants.actualisation.relachez')
                          : t('composants.actualisation.tirez')}
                </Text>
            </div>
        </div>
    );
}
